module.exports = __webpack_public_path__ + "img/hands-holding-dollar.6dde449c.svg";